import { useState } from "react";
import { Box, Table, TableCell, TableHead, TableRow } from "@mui/material";
import { makeStyles } from "@mui/styles";
import Fab from "@mui/material/Fab";
import EditIcon from "@mui/icons-material/Edit";
import { BASE_URL } from "../../../../services/client/rest";
import axios from "axios";
import PopoverComponent from "../Popover/PopoverComponent";
import { useQuery } from "react-query";
import AlertApi from "../../../../services/API/Alert.Api";

const ServerAlerts = () => {
  // const [sreverRow, SetServerRow] = useState([] as any);
  // const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  // const [name, SetName] = useState("");
  // const [note, SetNote] = useState("");
  // const open = Boolean(anchorEl);

  const classes = useStyles();

  // var bearer = "Bearer " + localStorage.getItem("token");
  // const headers = {
  //   Authorization: bearer,
  // };

  //---------------------- Fetching Live Alert Data ----------------------//
  const { data, refetch } = useQuery(
    ["GetAspenAnonymousUserAlerts"],
    () => AlertApi.getAspenAnonymousUserAlerts(),
    {
      initialData: [],
      refetchInterval: 2000 * 60 * 1,
      refetchIntervalInBackground: true,
    }
  );

  // const handleServerRowClick = (
  //   event: React.MouseEvent<HTMLButtonElement>,
  //   currentRow: any
  // ) => {
  //   setAnchorEl(event.currentTarget);
  //   SetServerRow(currentRow);
  // };

  // Submit Handler:
  // function OnSaveClick() {
  //   const request = {
  //     id: sreverRow.id,
  //     type: sreverRow.type,
  //     server: sreverRow.server,
  //     acknowledge: true,
  //     techRepresentative: name + "," + note,
  //   };

  //   axios
  //     .post(BASE_URL + "ServerInfo/AckServerAlert", request, {
  //       headers,
  //     })
  //     .then((response) => {
  //       setAnchorEl(null); // Close Popover:
  //       SetName("");
  //       SetNote("");
  //       refetch(); // Refetch Alert data:
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //       setAnchorEl(null); // Close Popover:
  //     });
  // }

  return (
    <Box
      style={{ display: "table", marginTop: "20px", minWidth: "100%" }}
      alignItems="center"
    >
      <fieldset
        style={{
          fontSize: "large",
          fontWeight: "bold",
          border: "1px solid silver",
        }}
      >
        <legend>&nbsp;Aspen Anonymous Users Alerts&nbsp;</legend>
        <Table aria-label="simple table" className={"myTable"}>
          <TableHead>
            <TableRow>
              <TableCell>Server</TableCell>
              <TableCell>CPU(%)</TableCell>
              <TableCell>Memory Usage(%)</TableCell>
              <TableCell>AvailableDiskSpace</TableCell>
              <TableCell>LastUpdate</TableCell>
              <TableCell>Current Connections</TableCell>
              <TableCell>Anonymous Users</TableCell>
            </TableRow>
          </TableHead>

          {data.length > 0 ? (
            data.map((row: any, index: any) => {
              let lastUpdate = "";
              if (row.lastUpdate != null)
                lastUpdate = new Date(row.lastUpdate).toLocaleDateString();

              let classAlert = "";
              if (row.alertCause === "Low Disk Space.")
                classAlert = classes.alert;

              let cpuAlert = "";
              if (parseInt(row.cpu.replace("%", "")) >= 50)
                cpuAlert = classes.alertMedium;
              if (parseInt(row.cpu.replace("%", "")) >= 75)
                cpuAlert = classes.alert;

              let memoryAlert = "";
              if (row.alertCause === "Low RAM Space")
                memoryAlert = classes.alert;

              let anonymousUsersAlert = "";
              if (row.showAlert === true) anonymousUsersAlert = classes.alert;

              return (
                <TableRow
                  hover
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  role="checkbox"
                >
                  <TableCell>{row.server}</TableCell>

                  <TableCell className={cpuAlert}>{row.cpu}</TableCell>

                  <TableCell className={memoryAlert}>{row.memory}</TableCell>

                  <TableCell className={classAlert}>
                    {row.availableDiskSpace}
                  </TableCell>

                  <TableCell>{lastUpdate}</TableCell>

                  <TableCell align="center">{row.currentConnections}</TableCell>

                  <TableCell align="center" className={anonymousUsersAlert}>
                    {row.anonymousUsers}
                  </TableCell>
                </TableRow>
              );
            })
          ) : (
            <TableRow
              hover
              sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              role="checkbox"
            >
              <TableCell
                align="center"
                colSpan={10}
                style={{
                  fontSize: "18pt",
                  fontWeight: "bold",
                }}
              >
                No Record Found
              </TableCell>
            </TableRow>
          )}
        </Table>
      </fieldset>

      {/* <PopoverComponent
        open={open}
        anchorEl={anchorEl}
        setAnchorEl={setAnchorEl}
        SetName={SetName}
        SetNote={SetNote}
        OnSaveClick={OnSaveClick}
      /> */}
    </Box>
  );
};

export default ServerAlerts;

const useStyles = makeStyles((theme) => ({
  root: {
    flexShrink: 0,
  },
  alert: { backgroundColor: "#E74C3C", color: "white" },
  alertMedium: { backgroundColor: "orange", color: "white !important" },
  hideCell: {
    display: "none !important",
  },
}));
